import axios from "axios";

import { DEFAULT_HEADERS } from "@/services/services.constants";
import {
  insertAcceptLanguageInterceptor,
  insertTokenInterceptor,
  responseErrorHandler,
  responseSuccessHandler,
} from "@/services/services.interceptors";

const appClient = axios.create({
  baseURL: String(import.meta.env.VITE_ARYA_EMS_URL),
  headers: {
    ...DEFAULT_HEADERS,
  },
  timeout: 300000,
});

appClient.interceptors.request.use(insertTokenInterceptor);
appClient.interceptors.request.use(insertAcceptLanguageInterceptor);

appClient.interceptors.response.use(
  responseSuccessHandler,
  responseErrorHandler,
);

export default appClient;
